import { render, staticRenderFns } from "./TripsSearchInput.vue?vue&type=template&id=520a6750&scoped=true&"
import script from "./TripsSearchInput.vue?vue&type=script&lang=js&"
export * from "./TripsSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./TripsSearchInput.vue?vue&type=style&index=0&id=520a6750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a6750",
  null
  
)

/* custom blocks */
import block0 from "./TripsSearchInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports